// ignore file coverage
import cuid from 'cuid';
// use shorter ids in development & testing
export var newid = process.env.NODE_ENV === 'production'
    ? cuid
    : function (len) {
        if (len === void 0) { len = 4; }
        return cuid()
            .split('')
            .reverse()
            .slice(0, len)
            .join('');
    }; //the beginning of a cuid changes slowly, use the end
//# sourceMappingURL=newid.js.map